// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2fM_M","buttons":"PendingPaymentAlert_buttons__1eXNm"};